export default __webpack_public_path__ + "locales/sr-Latn-RS/Common.json?hash=2246d53dd7d223abab42165bf3465b1d";